import { PublicChannelVideos } from '@wix/wix-vod-api-site-based/dist/src/public/services/channel-videos/channel-videos';
import { toError } from 'api/parsers/transport-error';
import { parseVideoItem } from 'api/parsers/video-item';
import { publicCatalogServiceConfig } from 'api/config/catalog-service';
import { hydratedData } from 'services/hydrated-data';

const service = new PublicChannelVideos(publicCatalogServiceConfig);

export const listChannelVideos = async ({
  channelId,
  query,
  tag,
  category,
  mediaType,
  sort,
  paging,
}) => {
  try {
    const response =
      hydratedData.getChannelVideosResponse() ||
      (await service.getList({
        channelId,
        query,
        tag,
        category,
        mediaType,
        sort,
        paging,
      }));

    return {
      ...response,
      data: _.map(response.data.items, parseVideoItem),
      sort,
      paging: {
        size: response.data.items.length,
        cursor: response.data.cursor,
      },
    };
  } catch (error) {
    return toError(toError);
  }
};

export const getChannelVideoById = async (
  channelId,
  videoId,
  hydratedResponse,
) => {
  try {
    const response =
      hydratedResponse ||
      (await service.getChannelVideoById(channelId, videoId));

    return {
      ...response,
      data: parseVideoItem(response.data),
    };
  } catch (error) {
    return toError(error);
  }
};

export const getSingleVideoById = (channelId, videoId) =>
  getChannelVideoById(
    channelId,
    videoId,
    hydratedData.getSingleVideoResponse(),
  );
